var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFillingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2136_9353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.76999 21H18.23",
    stroke: "#F4A460",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9 7.00007C20.7629 6.41784 20.473 5.88276 20.06 5.45007C19.653 5.01307 19.1396 4.68917 18.57 4.51007C17.9989 4.33708 17.393 4.31298 16.81 4.44007C16.2249 4.56835 15.6836 4.84761 15.24 5.25007C14.9971 4.58606 14.556 4.01272 13.9765 3.60766C13.397 3.20259 12.707 2.98535 12 2.98535C11.2929 2.98535 10.603 3.20259 10.0235 3.60766C9.44396 4.01272 9.0029 4.58606 8.75999 5.25007C8.31636 4.84761 7.77507 4.56835 7.18999 4.44007C6.60695 4.31298 6.0011 4.33708 5.42999 4.51007C4.86034 4.68917 4.34694 5.01307 3.93999 5.45007C3.57316 5.83917 3.30181 6.30822 3.14735 6.82019C2.99289 7.33215 2.95956 7.87301 3.04999 8.40007C3.12117 8.85964 3.28811 9.29913 3.53999 9.69007C3.79639 10.0924 4.1377 10.4337 4.53999 10.6901C4.92169 10.9575 5.35377 11.1447 5.80999 11.2401V16.1501C5.81257 16.5162 5.95848 16.8667 6.21644 17.1266C6.4744 17.3864 6.82389 17.5348 7.18999 17.5401H16.89C17.2561 17.5348 17.6056 17.3864 17.8635 17.1266C18.1215 16.8667 18.2674 16.5162 18.27 16.1501V11.2401C18.7262 11.1447 19.1583 10.9575 19.54 10.6901C19.9423 10.4337 20.2836 10.0924 20.54 9.69007C20.7813 9.29671 20.938 8.85736 21 8.40007C21.065 7.93154 21.0309 7.4546 20.9 7.00007Z",
    stroke: "#F4A460",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.76999 14.0801H18.23",
    stroke: "#F4A460",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2136_9353"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFillingIcon);
export default __webpack_public_path__ + "static/media/filling-icon.ed4f1ddff6b6bfa737c7454f6f9c92f3.svg";
export { ForwardRef as ReactComponent };